<script lang="ts">
  import { toasts, dismissToast } from '../lib/stores/toasts';
</script>

{#if $toasts.length > 0}
  <div class="toasts" role="status" aria-live="polite">
    {#each $toasts as toast (toast.id)}
      <div class="toast">
        <span>{toast.msg}</span>
        {#if toast.action}
          {@const action = toast.action}
          <button
            type="button"
            onclick={() => {
              action.fn();
              dismissToast(toast.id);
            }}
          >
            {action.label}
          </button>
        {/if}
      </div>
    {/each}
  </div>
{/if}
